import { ProtectedState } from "./types";
import { CurrentApr } from "./current-apr";
import { ProjectedApr } from "./projected-apr";
import { Option, pipe } from "effect";
import { getProtectedAprMetrics } from "@silo/utils";
import { AprState } from "../apr-state";
import { Percent } from "@silo/types";

export interface ProtectedAprSimulatorProps {
  currentState: ProtectedState;
  newState: ProtectedState | null;
  nativeRewardsSymbol: string;
  revenueApr: Percent;
  newRevenueApr: Percent;
}

export function ProtectedAprSimulator({
  currentState,
  newState,
  nativeRewardsSymbol,
  revenueApr,
  newRevenueApr,
}: ProtectedAprSimulatorProps): JSX.Element {
  const currentMetrics = getProtectedAprMetrics(
    currentState,
    nativeRewardsSymbol,
    revenueApr
  );

  const newMetrics = pipe(
    newState,
    Option.fromNullable,
    Option.map((newState) =>
      getProtectedAprMetrics(newState, nativeRewardsSymbol, newRevenueApr)
    ),
    Option.getOrNull
  );

  return (
    <>
      <CurrentApr currentMetrics={currentMetrics} revenueApr={revenueApr} />

      <ProjectedApr newMetrics={newMetrics} newRevenueApr={newRevenueApr} />

      <AprState aprState={null} utilizationState="optimal" />
    </>
  );
}
